import axios from 'axios';
import { BASE_URL } from 'constants/env';

export const CREATE_MACRO = async (e) => {
  const res = await axios.post(BASE_URL + `/admin/kb/macros/create`, {
    ...e,
  });
  return res.data;
};
